export default __webpack_public_path__ + "static/media/img_shop-type04.93b73101.png";